// src/api/features/payment-links/queries.ts
import { useQuery, keepPreviousData, type QueryKey } from "@tanstack/react-query";

import { listPaymentLinks, getPaymentLink } from "./api";
import { PaymentLinksKeys } from "./types";
import type { PaymentLinkDTO } from "./types";

/** List payment links with pagination + filters. */
export function usePaymentLinks(params: PaymentLinkDTO.ListParams = {}) {
  return useQuery({
    queryKey: PaymentLinksKeys.list(params),
    queryFn: () => listPaymentLinks(params),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
    gcTime: 5 * 60_000,
  });
}

/** Get a single payment link by id. */
export function usePaymentLink(id: number | null | undefined) {
  const enabled = typeof id === "number";
  return useQuery({
    queryKey: enabled
      ? PaymentLinksKeys.detail(id as number)
      : (["payment-links", "detail", "disabled"] as QueryKey),
    queryFn: () => getPaymentLink(id as number),
    enabled,
    staleTime: 30_000,
    gcTime: 10 * 60_000,
  });
}
